import intervalToDuration from "date-fns/intervalToDuration";

const numberToString = (v: number): string => (v < 10 ? `0${v}` : `${v}`);

export const secondsToFormatedTime = (seconds: number): string => {
    const duration = intervalToDuration({
        start: 0,
        end: seconds * 1000,
    });
    const v: string = [duration.hours, duration.minutes, duration.seconds]
        .reduce((acc: string[], current: number | undefined, idx: number) => {
            if (current !== undefined && current > 0) {
                return [...acc, numberToString(current)];
            }
            if (current !== undefined && idx >= 1) {
                return [...acc, numberToString(current)];
            }
            return acc;
        }, [])
        .join(":");
    return v;
};
